/* eslint-disable max-len */
import React, { useEffect, useState } from 'react'

import { useHistory } from 'react-router-dom'

import { toast } from 'react-toastify'

import bancos from '../../../../../presentation/assets/png/bancos.png'
import Signup5Doctor from '../../../../../presentation/pages/doctors/amplify/signup4'

import { makePlansPublic } from '../../../../usecases/plans/remote-plans-factory'
import { makePlanRegister } from '../../../../usecases/doctors/remote-doctors-factory'

import { errorsMessages } from '../../../../../presentation/helpers/helper-translation'
import { PaymentOptions } from '../../../../../presentation/helpers'
import { RoutesEnum, PaymentType } from '../../../../../presentation/enums'

const MakeSignup5Doctor: React.FC = () => {
  window.dataLayer.push({
    event: 'signupDoctor4',
  })
  document.title = 'Buscar Médicos - Cadastro - Passo 4'

  const history = useHistory()
  const [errorMessage, setErrorMessage] = useState<string | null>('')
  const [plan, setPlan] = useState([])
  const [installmentsOptions, setInstallmentsOptions] = useState<
    { value: string; label: string }[]
  >([])
  const [paymentMethod, setPaymentMethod] = useState<PaymentType>(
    PaymentType.CREDIT,
  )

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await makePlansPublic().load({ type: 'MEDICO' })
        const plans = response.content.map((item: any) => ({
          id: item.id,
          planTitle: item.planTitle,
          values: item.values,
          period: item.period,
          promotionalPrice: item.promotionalPrice,
        }))
        setPlan(plans)
      } catch (error) {
        toast.error('Erro ao carregar planos.')
      }
    }

    fetchData()
  }, [])

  const parseSelectedPlan = (data: any) => {
    const persedPlan = JSON.parse(data)
    return {
      value: parseFloat(persedPlan?.values || 0),
      period: persedPlan?.name,
      promotionalValue: parseFloat(persedPlan?.promotionalPrice || 0),
      rawPlan: persedPlan,
    }
  }

  const calculatePlanTotalValue = (value: number, promotionalValue: number) => promotionalValue || value

  const getInstallmentCount = (period: string) => {
    switch (period) {
      case 'Anual':
        return 12
      case 'Semestral':
        return 6
      case 'Trimestral':
      default:
        return 3
    }
  }

  const generateInstallmentOptions = (
    totalValue: number,
    maxInstallments: number,
    _plan: any,
  ) => Array.from({ length: maxInstallments }, (_, index) => {
    const installmentNumber = index + 1
    const installmentValue = totalValue / installmentNumber

    return {
      value: JSON.stringify({
        ..._plan,
        installments: installmentNumber,
      }),
      label: `${installmentNumber}X de R$${installmentValue.toFixed(2)}`,
    }
  })

  const HandlePlanSelect = (data: any) => {
    const {
      value, period, promotionalValue, rawPlan,
    } = parseSelectedPlan(data)
    const totalValue = calculatePlanTotalValue(value, promotionalValue)

    if (totalValue) {
      const maxInstallments = paymentMethod === PaymentType.DEBIT ? 1 : getInstallmentCount(period)
      const newInstallmentsOptions = generateInstallmentOptions(
        totalValue,
        maxInstallments,
        rawPlan,
      )
      setInstallmentsOptions(newInstallmentsOptions)
    }
  }

  const serializePlan = (_plan: any) => JSON.stringify({
    id: _plan.id,
    name: _plan.period,
    values: _plan.values,
    promotionalPrice: _plan.promotionalPrice,
  })

  const calculateTotalValue = (_plan: any) => _plan.promotionalPrice || _plan.values

  const generateInstallmentLabel = (
    totalValue: number,
    installmentCount: number,
  ) => `até ${installmentCount}x de R$${(totalValue / installmentCount).toFixed(
    2,
  )}`

  const options = plan.map((plans: any, index: number) => {
    const value = serializePlan(plans)
    const totalValue = calculateTotalValue(plans)
    const installmentCount = getInstallmentCount(plans.period)
    const label3 = generateInstallmentLabel(totalValue, installmentCount)

    return {
      value,
      name: plans.period,
      label: `R$${plans.promotionalPrice || plans.values}`,
      label2: plans.promotionalPrice ? `R$${plans.values}` : null,
      label3,
      key: index.toString(),
    }
  })

  const handlePaymentMethodChange = (value: string) => {
    setPaymentMethod(value as PaymentType)
  }

  const dataForm = [
    {
      items: [
        {
          component: 'Title',
          subtitle: 'Escolha seu plano',
        },
        {
          component: 'Title',
          subtitle:
            'Você começa a pagar só após 1 ano grátis e depois independente do plano escolhido, pode cancelar a qualquer momento sem custo algum!',
        },
        {
          name: 'options',
          component: 'InputCheck',
          options,
          required: true,
          onChange: HandlePlanSelect,
        },
        {
          component: 'InputGroup',
          style: {
            alignItems: 'center',
          },
          inputs: [
            {
              component: 'Title',
              subtitle: 'Forma de pagamento',
              textColorBlack: true,
              images: bancos,
            },
            {
              component: 'InputRadio',
              name: 'paymentMethod',
              title: 'Forma de pagamento',
              defaultValue: PaymentType.CREDIT,
              onChange: handlePaymentMethodChange,
              options: PaymentOptions,
            },
          ],
        },
        {
          component: 'InputMask',
          mask: 'CREDIT_CARD_NUMBER',
          name: 'cardNumber',
          styleContainer: {
            display: paymentMethod === PaymentType.BOLETO ? 'none' : 'flex',
          },
          label: 'Número do cartão',
          title: 'Número do cartão',
          type: 'tel',
          value: '',
          required: true,
          placeholder: 'Digite aqui',
          validations:
            paymentMethod !== PaymentType.BOLETO ? 'inputRequired' : null,
        },
        {
          component: 'InputGroup',
          style: {
            display: paymentMethod === PaymentType.BOLETO ? 'none' : 'flex',
          },
          inputs: [
            {
              component: 'InputMask',
              mask: 'EXPIRATION_DATE',
              name: 'data',
              label: 'Data de validade',
              title: 'Data de validade',
              type: 'tel',
              value: '',
              required: true,
              placeholder: 'Digite aqui',
              validations:
                paymentMethod !== PaymentType.BOLETO ? 'inputRequired' : null,
            },
            {
              name: 'cod',
              component: 'Input',
              value: '',
              placeholder: 'Digite aqui',
              type: 'number',
              title: 'Código de segurança',
              label: 'Código de segurança',
              required: true,
              validations:
                paymentMethod !== PaymentType.BOLETO ? 'inputRequired' : null,
            },
          ],
        },
        {
          name: 'name',
          component: 'Input',
          value: '',
          placeholder: 'Digite aqui',
          styleContainer: {
            display: paymentMethod === PaymentType.BOLETO ? 'none' : 'flex',
          },
          type: 'text',
          title: 'Nome no cartão',
          label: 'Nome no cartão',
          required: true,
          validations:
            paymentMethod !== PaymentType.BOLETO ? 'inputRequired' : null,
        },
        {
          component: 'InputMask',
          mask: 'CPF',
          name: 'holderDocument',
          label: 'CPF do titular',
          title: 'CPF do titular',
          styleContainer: {
            display: paymentMethod === PaymentType.BOLETO ? 'none' : 'flex',
          },
          type: 'tel',
          value: '',
          required: true,
          placeholder: 'Digite aqui',
          validations:
            paymentMethod !== PaymentType.BOLETO ? 'inputRequired' : null,
        },
        {
          name: 'parcela',
          component: 'Select',
          styleContainer: {
            display: paymentMethod === PaymentType.BOLETO ? 'none' : 'flex',
          },
          value: '',
          title: 'Parcela',
          label: 'Digite o valor',
          required: true,
          options: installmentsOptions.map((item: any) => ({
            value: item.value,
            label: item.label,
          })),
          hasPlusButton: false,
        },
        {
          component: 'Title',
          subtitle:
            'Você concluirá o cadastro e após os 1 ano de gratuidade, o boleto será gerado. Ele será enviado para o seu e-mail e também estará disponível no seu perfil de usuário.',
          style: {
            display: paymentMethod === PaymentType.BOLETO ? 'flex' : 'none',
          },
        },
        {
          name: 'button',
          component: 'Button',
          title: 'Prosseguir',
          submittingText: 'Carregando...',
          color: true,
        },
      ],
    },
  ]

  const validateCardBrand = (cardNumber: string): string => {
    const firstDigit = cardNumber.charAt(0)

    if (firstDigit === '3') {
      return 'Diners Club / American Express'
    }
    if (firstDigit === '4') {
      return 'Visa'
    }
    if (firstDigit === '5') {
      const secondDigit = cardNumber.charAt(1)
      if (['1', '2', '3', '4', '5'].includes(secondDigit)) {
        return 'Mastercard'
      }
    } else if (firstDigit === '6') {
      return 'Discover'
    }

    return 'Unknown'
  }

  const handleCardPayment = async (values: any, storedEmail: string) => {
    const cardBrand = validateCardBrand(values.cardNumber)
    if (cardBrand === 'Unknown') {
      setErrorMessage('Bandeira do cartão não suportada.')
      return
    }

    const cleanedHolderDocument = values.holderDocument.replace(/[^\d]/g, '')

    const requestBody = {
      email: storedEmail,
      planId: JSON.parse(values.parcela).id,
      paymentMethod: values.paymentMethod,
      card: {
        number: values.cardNumber,
        holderDocument: cleanedHolderDocument,
        holderName: values.name,
        expMonth: parseInt(values.data.split('/')[0], 10),
        expYear: parseInt(values.data.split('/')[1], 10),
        cvv: values.cod,
        brand: cardBrand,
        installments: JSON.parse(values.parcela).installments,
      },
    }
    try {
      await makePlanRegister('step-four').post(requestBody)
      history.push(RoutesEnum.TERMS_DOCTOR)
    } catch (error: any) {
      toast.error(errorsMessages[error.message] || error.message, {
        autoClose: 10000,
      })
    }
  }

  const handleBoletoPayment = async (values: any, storedEmail: string) => {
    const requestBody = {
      email: storedEmail,
      paymentMethod: values.paymentMethod,
      planId: JSON.parse(values.options[0]).id,
    }
    try {
      await makePlanRegister('step-four').post(requestBody)
      history.push(RoutesEnum.TERMS_DOCTOR)
    } catch (error: any) {
      toast.error(errorsMessages[error.message] || error.message, {
        autoClose: 10000,
      })
    }
  }

  const onSubmit = async (values: any): Promise<void> => {
    const storedEmail = localStorage.getItem('userEmail')

    if (!storedEmail) {
      setErrorMessage('Usuário não encontrado.')
      return
    }

    if (paymentMethod === PaymentType.BOLETO) {
      await handleBoletoPayment(values, storedEmail)
    } else {
      await handleCardPayment(values, storedEmail)
    }
  }

  return (
    <Signup5Doctor
      dataForm={dataForm}
      onSubmit={onSubmit}
      errorMessage={errorMessage}
    />
  )
}

export default MakeSignup5Doctor
